import React, { useCallback, useState } from "react";
import styled from "styled-components";
import { FaEye, FaEyeSlash } from "react-icons/fa";

// Move styled components outside of the functional component

function TextField({ width, height, title, direction, type, value, setValue }) {
  const [showPassword, setShowPassword] = useState(false);

  const handleOnChange = useCallback(
    (e) => {
      setValue(e.target.value);
    },
    [setValue]
  );

  const isPasswordField = type === "password";
  const displayType = isPasswordField && showPassword ? "text" : type;

  return (
    <Container direction={direction}>
      <Title>{title}</Title>
      <FieldContainer>
        <Field
          onChange={handleOnChange}
          value={value}
          type={displayType}
          width={width}
          height={height}
        />
        {isPasswordField && (
          <PasswordToggle onClick={() => setShowPassword(!showPassword)}>
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </PasswordToggle>
        )}
      </FieldContainer>
    </Container>
  );
}

const Title = styled.div`
  text-wrap: wrap;
`;

const Container = styled.div`
  display: flex;
  align-items: ${(props) =>
    props.direction === "column" ? "flex-start" : "center"};
  justify-content: center;
  gap: 5px;
  flex-direction: ${(props) => (props.direction ? props.direction : "row")};
  flex-wrap: wrap;
  color: #304961;
  text-align: right;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: italic;
  font-weight: 300;

  @media screen and (max-width: 662px) {
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
  }
`;

const FieldContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

const Field = styled.input`
  padding: 10px;
  width: ${(props) => (props.width ? props.width : "240px")};
  height: ${(props) => (props.height ? props.height : "26px")};
  background-color: var(--white);
  border-radius: 4px;
  border: none;

  &:focus {
    outline: none;
    box-shadow: 0px 0px 1px 2px orange;
  }

  @media screen and (max-width: 662px) {
    width: 100%;
  }
`;

const PasswordToggle = styled.div`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #304961;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  
  &:hover {
    color: #1a2c3d;
  }
`;

export default TextField;
